<h1 style="text-align: center;">Scientific Session</h1>
<h2>Description</h2>
<p>
    The Scientific Session of CIFRIS24 is dedicated to advancing knowledge and fostering collaboration among researchers
    in the field of cryptography. This session features a series of invited and contributed talks, selected by the
    Chairs and the Programme Committee from submitted papers. Participants will have the opportunity to present and
    discuss their latest research findings, methodologies, and theoretical advancements. Covering a wide range of
    topics, from foundational cryptographic theories to practical applications, the Scientific Session aims to stimulate
    intellectual exchange and inspire innovative solutions to contemporary challenges in cryptography. This gathering
    serves as a vibrant forum for sharing cutting-edge research and forging new collaborations within the global
    cryptographic community.
</p>
<h2>Program</h2>
<p>
    <i> September 25th, 26th</i>
    <br>
    <i> Main Hall</i>
</p>
<app-orari-scientific-session24></app-orari-scientific-session24>